import { Box, Typography } from "@mui/material";
import aboutImage from "../../assets/Backgrounds/Profile_boy.webp";
import 'aos/dist/aos.css'; // Import AOS styles (remove if not used)

const Whysteam = ({ Statistics, imagebackground }) => {
  // Ensure Statistics is an array, default to empty array if not
  const statsArray = Array.isArray(Statistics) ? Statistics : [];

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "60vh", sm: "50vh", md: "50vh" },
        backgroundImage: `url(${
          imagebackground[3]?.image
            ? `https://mindsinaction.com.na/assets/media/pictures/${imagebackground[0].image}`
            : aboutImage
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: { xs: "60vh", sm: "50vh", md: "50vh" },
          backgroundColor: "#0000007c",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          alignItems: "center",
          gap: '2rem'
        }}
      >
        <h1
          className='primary-header'
          style={{
            background:
              "linear-gradient(90deg, rgba(4, 110, 209, 0.52) 0%, rgba(255, 255, 255, 0.73) 100%)",
            textTransform: 'uppercase', color: '#fff', padding: '1rem'
          }}
          data-aos="fade-up" // Animation for title
          data-aos-delay="100"
        >
          Why Mindsinaction STEAM Centre
        </h1>
        <Box
          width={{xs: '95%', ms: '80%', md: '80%'}}
          display={'flex'}
          flexWrap={'wrap'}
          alignItems={'start'}
          justifyContent={'space-evenly'}
          padding={'2rem'}
          borderRadius={5}
          sx={{
            background:
              "linear-gradient(90deg, rgba(0, 132, 255, 0.77) 0%, rgba(255, 255, 255, 0.73) 100%)",
          }}
        >
          {statsArray.map((stats) =>
            stats.description !== null && stats.numbers !== null && (
              <Box key={stats.id} width={{xs: '140px', ms: '200px', md: '200px'}} data-aos="zoom-in"
              data-aos-delay={`${200 + 1 * 100}`} >
                <Typography variant='h2' sx={{ fontSize: {xs: '3rem', ms: '3.5rem', md: '4rem'}, fontWeight: '700', color: '#fff' }}>{stats.numbers >= 5000 ? "5K+": `${stats.numbers}`}</Typography>
                <Typography
                  dangerouslySetInnerHTML={{ __html: stats.description }}
                  borderTop={'.1rem solid #fff'} color="#fff" fontWeight={700}
                />
              </Box>
            )
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Whysteam;